import * as React from 'react';

function SvgPin(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 9.464 13.737" {...props}>
      <path
        d="M9.24 3.419a4.28 4.28 0 00-.222-.55A4.706 4.706 0 00-.005 4.262v.586c0 .024.008.244.02.354.171 1.368 1.25 2.821 2.056 4.188.867 1.465 1.767 2.906 2.658 4.347.55-.94 1.1-1.893 1.634-2.809.146-.269.316-.537.463-.794.1-.171.284-.342.37-.5.867-1.587 2.262-3.187 2.262-4.762v-.647a4.874 4.874 0 00-.218-.806zM4.706 6.362a1.68 1.68 0 01-1.611-1.148 1.592 1.592 0 01-.045-.428v-.378a1.59 1.59 0 011.706-1.563A1.729 1.729 0 016.495 4.6a1.774 1.774 0 01-1.789 1.762z"
        fill="#c83526"
      />
    </svg>
  );
}

export default SvgPin;
